import React from 'react';
import '../../App.css';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPage() {
  return (
    <div className="page info-page privacy-policy-page">
      <div className="info-columns">
        <div className="info-column">
          <h2>Privacy Policy</h2>

          <p>We care about your personal privacy. This policy explains how we collect and use personal data.</p>
          
          <h3>What data do we collect?</h3>
          <ul>
            <li>Name, address, email, and phone number (when placing an order or contacting us)</li>
            <li>Payment information (handled by our payment partners, e.g. Klarna/Stripe)</li>
            <li>Order history</li>
            <li>Technical information (e.g. IP address, cookies for analytics/statistics)</li>
          </ul>

          <h3>Why do we collect the data?</h3>
          <ul>
            <li>To process orders and deliveries</li>
            <li>For customer service and support</li>
            <li>To meet bookkeeping and legal obligations</li>
            <li>To improve our website (statistics/analytics)</li>
          </ul>

          <h3>How long is data stored?</h3>
          <p>We only store data for as long as necessary for each purpose or as required by law.</p>

          <h3>Your rights</h3>
          <p>You have the right to request access, correction, or deletion of your personal data. Contact us at <a href="mailto:admin@ideafarm.se">admin@ideafarm.se</a>.</p>
        </div>
        <div className="info-column">
          <h2>Integritetspolicy</h2>
          <p><strong>Integritetspolicy</strong></p>
          <p>Vi värnar om din personliga integritet. Denna policy förklarar hur vi samlar in och använder personuppgifter.</p>

          <h3>Vilka uppgifter samlas in?</h3>
          <ul>
            <li>Namn, adress, e-postadress och telefonnummer (vid beställning eller kontakt)</li>
            <li>Betalningsinformation (hanteras av våra betalningspartners, t.ex. Klarna/Stripe)</li>
            <li>Orderhistorik</li>
            <li>Tekniska uppgifter (t.ex. IP-adress, cookies för analys/statistik)</li>
          </ul>

          <h3>Varför samlar vi in uppgifterna?</h3>
          <ul>
            <li>För att hantera beställningar och leveranser</li>
            <li>För kundtjänst och support</li>
            <li>För bokföringsskyldigheter enligt lag</li>
            <li>För att förbättra vår webbplats (statistik/analys)</li>
          </ul>

          <h3>Hur länge sparas uppgifterna?</h3>
          <p>Vi sparar uppgifterna endast så länge det krävs för respektive ändamål eller enligt lag.</p>

          <h3>Dina rättigheter</h3>
          <p>Du har rätt att begära utdrag, rättelse eller radering av dina personuppgifter. Kontakta oss på <a href="mailto:admin@ideafarm.se">admin@ideafarm.se</a>.</p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
